import { GetVisitById, GetVisitByIdRejectedByEnum } from 'woofwoof-api';
import { translateKey } from 'src/locales/translate';

type VisitStatusInfo = {
  label: string;
  color:
    | 'default'
    | 'primary'
    | 'secondary'
    | 'info'
    | 'success'
    | 'warning'
    | 'error';
  icon?: string;
};

export const mapVisitStatusToString = (
  status: GetVisitById['status'] | undefined,
  rejectedBy?: GetVisitByIdRejectedByEnum,
): VisitStatusInfo | null => {
  if (!status) {
    return null;
  }

  // System-rejected visits share `status: REJECTED` with owner-rejected ones,
  // but we want to surface that the cron auto-rejected them after the approval
  // window — otherwise the owner can't tell the difference.
  if (status === 'REJECTED' && rejectedBy === GetVisitByIdRejectedByEnum.System) {
    return {
      label: translateKey("visit.calendarFilterStatusRejectedBySystem"),
      color: 'error',
      icon: 'solar:close-circle-bold',
    };
  }

  const statusMap: Record<string, VisitStatusInfo> = {
    CREATED: {
      label: 'Potwierdzona',
      color: 'success',
      icon: 'solar:check-circle-bold',
    },
    PENDING: {
      label: translateKey("common.live"),
      color: 'warning',
      icon: 'solar:hourglass-bold-duotone',
    },
    COMPLETED: {
      label: translateKey("visit.calendarFilterStatusCompleted"),
      color: 'success',
      icon: 'solar:check-circle-bold',
    },
    CANCELLED: {
      label: translateKey("hardcoded.odwolana"),
      color: 'error',
      icon: 'solar:close-circle-bold',
    },
    PENDING_APPROVAL: {
      label: 'Oczekuje na potwierdzenie',
      color: 'warning',
      icon: 'solar:hourglass-bold-duotone',
    },
    ACCEPTED: {
      label: 'Potwierdzona',
      color: 'success',
      icon: 'solar:check-circle-bold',
    },
    REJECTED: {
      label: translateKey("visit.calendarFilterStatusRejected"),
      color: 'error',
      icon: 'solar:close-circle-bold',
    },
    ABORTED: {
      label: translateKey("visit.calendarFilterStatusAborted"),
      color: 'error',
      icon: 'solar:close-circle-bold',
    },
  };

  return statusMap[status] || null;
};
